import React, { type FC, memo, useCallback, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { Button } from "@heroui/react";
import { type GQL } from "@binale-tech/shared";

import { BewirtungFields } from "@dms/components/Bewirtung/BewirtungFields";
import { type BewirtungFormValues, normalizeBewirtungInput } from "@dms/components/Bewirtung/bewirtungValidation";

type BewirtungFormProps = {
    initialValue: GQL.IDmsBewirtungInput;
    onSave: (value: GQL.IDmsBewirtungInput) => void;
    isPending?: boolean;
};

const BewirtungFormImpl: FC<BewirtungFormProps> = ({ initialValue, onSave, isPending }) => {
    const methods = useForm<BewirtungFormValues>({ defaultValues: { bewirtung: initialValue } });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        reset({ bewirtung: initialValue });
    }, [initialValue, reset]);

    const submit = useCallback(() => {
        void handleSubmit(({ bewirtung }) => {
            if (bewirtung) {
                onSave(normalizeBewirtungInput(bewirtung));
            }
        })();
    }, [handleSubmit, onSave]);

    return (
        <FormProvider {...methods}>
            <div className="flex flex-col gap-3" data-testid="bewirtung-form">
                <BewirtungFields />
                <div className="flex justify-end">
                    <Button variant="primary" onPress={submit} isPending={isPending} data-testid="bewirtung-save">
                        <FormattedMessage id="app.dms.bewirtung.save" />
                    </Button>
                </div>
            </div>
        </FormProvider>
    );
};

export const BewirtungForm = memo(BewirtungFormImpl);
